export default __webpack_public_path__ + "static/media/about4.4fda8010.jpg";